import { render } from "./OverviewCompanyBlock.vue?vue&type=template&id=b0582180&scoped=true"
import script from "./OverviewCompanyBlock.vue?vue&type=script&lang=js"
export * from "./OverviewCompanyBlock.vue?vue&type=script&lang=js"

import "./OverviewCompanyBlock.vue?vue&type=style&index=0&id=b0582180&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0582180"]])

export default __exports__